import { createFileRoute, notFound } from '@tanstack/react-router'
import { ProductPageViewModel } from '@/components/product/product-page/product-page.view-model'
import { NotFoundFloraViewModel } from '@/components/shared/not-found-flora/not-found-flora.view-model'
import { SITE_BASE_URL } from '@/constants/site'
import { buildPageMeta } from '@/lib/seo/build-page-meta'
import { productsQueryOptions } from '@/services/products/use-products'

export const Route = createFileRoute('/_editorial/produto/$slug')({
  loader: async ({ context, params }) => {
    const product = await context.queryClient.ensureQueryData(
      productsQueryOptions.bySlug(params.slug),
    )

    if (!product) {
      throw notFound()
    }

    await context.queryClient.ensureQueryData(
      productsQueryOptions.byCategory(product.category),
    )

    return product
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {}
    }

    const product = loaderData
    const title = `${product.name} — Flora Ateliê`
    const productUrl = `${SITE_BASE_URL}/produto/${product.slug}`
    const imageUrl = product.imagePath
      ? `${SITE_BASE_URL}${product.imagePath}`
      : undefined

    return {
      ...buildPageMeta({
        title,
        description: product.shortStory,
        path: `/produto/${product.slug}`,
        image: product.imagePath ?? undefined,
        type: 'product',
      }),
      scripts: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: product.name,
            description: product.shortStory,
            ...(imageUrl ? { image: imageUrl } : {}),
            brand: {
              '@type': 'Brand',
              name: 'Flora Ateliê',
            },
            offers: {
              '@type': 'Offer',
              price: (product.priceInCents / 100).toFixed(2),
              priceCurrency: 'BRL',
              availability: 'https://schema.org/InStock',
              url: productUrl,
            },
          }),
        },
      ],
    }
  },
  notFoundComponent: NotFoundFloraViewModel,
  component: ProdutoRouteComponent,
})

function ProdutoRouteComponent() {
  const product = Route.useLoaderData()
  return <ProductPageViewModel product={product} />
}
